'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _CouponCodes = require('./CouponCodes');

var _CouponCodes2 = _interopRequireDefault(_CouponCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@vg/coupon-codes')(_CouponCodes2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/coupon-codes/lib/cjs/index.js
 ** module id = 718
 ** module chunks = 1
 **/